import React from 'react';
import { motion } from 'framer-motion';
import './Mentorship.css';
import mentorshipImg from '../Images/mentor1.jpg'; // Use your high-resolution image
import { Link } from 'react-router-dom';

const Mentorship = () => {
  return (
    <div className="mentorship-wrapper">
      {/* Left Side: Text */}
      <motion.div
        className="mentorship-text-box"
        initial={{ x: -100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <motion.h2
          className="mentorship-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <span className="black-line">Achieve Career Growth with</span>
          <span className="blue-line"> Personalized Mentorship</span>
        </motion.h2>

        <motion.p
          className="mentorship-description"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          Unlock personalized support, expert feedback, and hands-on guidance to elevate your career path.
          Get mentored by seasoned professionals ready to walk with you step-by-step.
        </motion.p>

        <div className="mentorship-features">
          {[
            '🎯 Custom Learning Paths',
            '💬 1-on-1 Mentor Sessions',
            '📘 Real-world Case Studies',
            '🗓 Weekly Progress Reviews',
          ].map((item, i) => (
            <motion.div
              key={i}
              className="mentorship-feature-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 + i * 0.2 }}
            >
              {item}
            </motion.div>
          ))}
        </div>

        <div className="mentorship-buttons">
          {/* <Link to= "/SignupForm">  */}
          <motion.button className="mentorship-btn primary" whileHover={{ scale: 1.05 }}>
            Connect Now
          </motion.button>
          {/* </Link> */}
          <motion.button className="mentorship-btn secondary" whileHover={{ scale: 1.05 }}>
            Learn More
          </motion.button>
        </div>
      </motion.div>

      {/* Right Side: Image */}
      <motion.div
        className="mentorship-image-box"
        initial={{ x: 100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <motion.img
          src={mentorshipImg}
          alt="Mentorship Visual"
          className="mentorship-main-image"
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 4, repeat: Infinity }}
        />
      </motion.div>
    </div>
  );
};

export default Mentorship;
